import * as React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { EndlessList, IEndlessList } from "ui/Scripts/source/models/common/endlessList";
import { SelectIdCodeDialog } from "../framework/selectIdCodeDialog";
import { IdCode, IIdCode } from "source/models/common/idCode";
import { IIdCodeDivider } from "source/models/common/idCodeDivider";

export interface ITaskPrintDialogProps {
    onOk: (rowAmount: number) => void;
    onClose: () => void;
}

export const TaskPrintDialog = (props: ITaskPrintDialogProps) => {
    const handleLoadIdCodes = (page: number): Promise<IEndlessList<IIdCodeDivider>> => {
        return new Promise<IEndlessList<IIdCode>>((resolve, reject) => {
            const result = new EndlessList<IIdCode>(null, IdCode);
            result.items = [{ id: "0", code: `0 ${Translations.Rows.toLocaleLowerCase()}` },
                { id: "10", code: `10 ${Translations.Rows.toLocaleLowerCase()}` },
                { id: "20", code: `20 ${Translations.Rows.toLocaleLowerCase()}` },
                { id: "50", code: `50 ${Translations.Rows.toLocaleLowerCase()}` },
                { id: "100", code: `100 ${Translations.Rows.toLocaleLowerCase()}` },
                { id: "250", code: `250 ${Translations.Rows.toLocaleLowerCase()}` },
                { id: "500", code: `500 ${Translations.Rows.toLocaleLowerCase()}` },
                { id: "1000", code: `1000 ${Translations.Rows.toLocaleLowerCase()}` }
            ];
            result.page = 1;
            result.hasMore = false;
            resolve(result);
        });
    };

    return (
        <SelectIdCodeDialog
            title={Translations.RowAmountIncludedInPrint}
            selectedId="10"
            loadIdCodes={handleLoadIdCodes}
            showOkButton={true}
            okButtonTitle={Translations.Print}
            onOk={(id: string, code: string) => {
                props.onOk(Number(id));
            }}
            onCancel={props.onClose}
        />
    );
};